import { inject } from '@angular/core';
import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';

export class GalleryUrlSerializer implements UrlSerializer {
  private readonly defaultSerializer = inject(DefaultUrlSerializer);

  public parse(url: string): UrlTree {
    return this.defaultSerializer.parse(url);
  }

  public serialize(tree: UrlTree): string {
    const path = this.defaultSerializer.serialize(tree);
    return path.replace(/%2F/g, '/');
  }
}
